module.exports = __webpack_public_path__ + "media/basic-details/webinar@1x-e48dd13a.png";